export const newsParsedDate = (date?:string) => {
  if(date){
    const newDate = date.replace('T', ' ');

    return newDate.split('.')[0];
  }

  return null;
};
